import {createSlice, PayloadAction,} from '@reduxjs/toolkit';
import loadFromLocalStorage from "../../util/storage/json/loadFromLocalStorage";
import saveToLocalStorage from "../../util/storage/json/saveToLocalStorage";
import {APP_TOKEN} from "../../Config";

const THEME_STATE_TOKEN = `${APP_TOKEN}THEME_STATE_TOKEN`;

export enum THEME_TOKEN {
    DARK = "DARK",
    LIGHT = "LIGHT",
}

const getIsDarkBrowserDefault = (): boolean => {
    return (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches);
}

export interface IThemeState {
    isDark: boolean;
    themeToken: THEME_TOKEN;
}

const isDarkBrowserDefault = getIsDarkBrowserDefault();
const initialState: IThemeState = {
    isDark: isDarkBrowserDefault,
    themeToken: isDarkBrowserDefault ? THEME_TOKEN.DARK : THEME_TOKEN.LIGHT,
};

const loadedState: IThemeState = loadFromLocalStorage(THEME_STATE_TOKEN, {...initialState});


export const themeSlice = createSlice({
    name: 'theme',
    initialState: loadedState,
    reducers: {
        setTheme: (state: IThemeState, action: PayloadAction<THEME_TOKEN>) => {
            const themeToken = action.payload;
            const isDark = themeToken === THEME_TOKEN.DARK;
            const updatedState = {
                ...state,
                isDark,
                themeToken,
            };
            saveToLocalStorage(THEME_STATE_TOKEN, updatedState);

            return updatedState;
        },
    },
});

export const {setTheme} = themeSlice.actions;
export default themeSlice.reducer;
